export enum ProjectBookmarkType {
  PROJECT = 'project',
  CONTEST = 'contest',
}

export interface ProjectBookmarksResultAjax {
  readonly project_id: number;
  readonly subscribed: 'true' | 'false';
  // subscribed is not a boolean because boolean `false` doesn't pass the php FormInput validation..
  readonly type: ProjectBookmarkType;
}
